import { gql, useQuery } from "@apollo/client";
import { getFetchPolicyOptions } from "api/utils";
import { SecurityDetailsQuery } from "@/api/types";

export const SECURITY_DETAILS_QUERY = gql`
  query GetSecurityDetails($securityId: Long) {
    security(id: $securityId) {
      id
      name
      securityCode
      isinCode
      classType2 {
        code
        value
        valuesAsMap
      }
      tagsAsSet
      issuer {
        id
        name
      }
      figuresAsObject {
        latestValues
      }
      documents {
        mimeType
        data
        fileName
        lastModified
      }
      issuerDescription
      managementFeePercentage
      kickBackPercentage
      latestMarketData {
        date: obsDate
        close1
      }
      url
      url2
      currency {
        securityCode
        name
      }
      country {
        id
        code
        name
        namesAsMap
      }
      description
    }
  }
`;

export const useGetSecurityDetails = (
  securityId: string | undefined,
  skip = false
) => {
  const { loading, error, data, refetch } = useQuery<SecurityDetailsQuery>(
    SECURITY_DETAILS_QUERY,
    {
      variables: { securityId },
      skip,
      ...getFetchPolicyOptions(`useGetSecurityDetails.${securityId}`),
    }
  );

  return {
    loading: loading,
    error: error,
    data: data && data,
    refetch,
  };
};
